import { GridIcon } from '../../icons/GridIcon';
import { Button } from '../Button';
import { Img, Placeholder } from '../ImageFrame';
import { ImageGallery } from '../ImageGallery';
import { Carousel, Cell, Mosaic, SecondaryGrid, ShowAll } from './HeroGallery.styles';
import type { HeroGalleryProps } from './HeroGallery.types';

const MOSAIC_CAPACITY = 5;

export function HeroGallery({
  images,
  onShowAll,
  showAllLabel = 'Show all photos',
  overlayContent,
  badge,
  onBack,
  backLabel,
}: HeroGalleryProps) {
  const mosaicImages = images.filter((image) => image.src).slice(0, MOSAIC_CAPACITY);
  const [hero, ...secondary] = mosaicImages;
  const count = mosaicImages.length;

  return (
    <>
      <Carousel data-gallery-view="carousel">
        <ImageGallery
          images={images}
          overlayContent={overlayContent}
          badge={badge}
          onBack={onBack}
          backLabel={backLabel}
          sticky={false}
        />
      </Carousel>
      <Mosaic data-gallery-view="mosaic" data-count={count}>
        {hero ? (
          <>
            <Cell>
              <Img src={hero.src ?? undefined} alt={hero.alt ?? ''} />
            </Cell>
            {secondary.length > 0 && (
              <SecondaryGrid data-count={count}>
                {secondary.map((image, index) => (
                  <Cell key={image.src ?? index}>
                    <Img src={image.src ?? undefined} alt={image.alt ?? ''} />
                  </Cell>
                ))}
              </SecondaryGrid>
            )}
          </>
        ) : (
          <Cell>
            <Placeholder />
          </Cell>
        )}
        {onShowAll && (
          <ShowAll>
            <Button variant="secondary" size="small" onClick={onShowAll}>
              <GridIcon />
              {showAllLabel}
            </Button>
          </ShowAll>
        )}
      </Mosaic>
    </>
  );
}
